import { render } from "./shopDetails.vue?vue&type=template&id=5fe6d078&scoped=true"
import script from "./shopDetails.vue?vue&type=script&lang=js"
export * from "./shopDetails.vue?vue&type=script&lang=js"

import "./shopDetails.vue?vue&type=style&index=0&id=5fe6d078&lang=less&scoped=true"

import exportComponent from "D:\\新建文件夹\\资料\\PC享赫生活\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe6d078"]])

export default __exports__